/* eslint-disable */
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Heading } from '@mediahuis/chameleon-react';
import { fontFamilyBrandPrimary, colorWhiteBase, fontFamilySystem } from '@mediahuis/chameleon-theme-wl';
import CloseIcon from './img/close.svg';
import ExpandIcon from './img/expand.svg';
import MinimizeIcon from './img/minimize.svg';
import UserAvatar from './img/user-avatar.svg';
import BrandAvatar from './img/avatar.svg';
import { styles } from './styles/'; // TODO: Refactor to styled components

var ChatbotExternalWrapper = styled.div.withConfig({
  displayName: "Chatbot__ChatbotExternalWrapper",
  componentId: "sc-11yfao3-0"
})(["font-size:16px;font-family:", ";width:100%;max-width:", ";box-shadow:0px 15px 30px -10px #bbb;border-radius:5px;margin:0 auto;bottom:0;right:0;margin:0 20px;position:fixed;z-index:10;a{color:white;text-decoration:underline;}@media all and (max-width:767px){max-width:100%;width:100%;margin:0;}.enter-input{text-align:right;margin-top:16px;}a.chatbot__send2{border-radius:4px;padding:4px 6px;background-color:", ";color:", ";margin-left:4px;text-decoration:none;font-family:", ";font-weight:bold;}.enter-input label{color:#aaa;}.chatbot__input.input{margin-bottom:0px;}.chatbot__header h2{font-family:", ";color:", ";text-align:center;font-size:20px;}.chatbot__content{padding:0 20px;font-size:15px;color:#635f5f;padding-bottom:20px;box-shadow:inset 0px -20px 30px -30px grey;background-color:white;}.chatbot__input{margin-top:16px;display:block;box-sizing:border-box;width:100%;-webkit-appearance:none;background-color:#fff;display:block;margin-bottom:0px;border:1px solid #a8a1a2;color:#635f5f;border-radius:5px;padding:10px;height:auto;overflow-y:auto;min-height:60px;font-size:15px;max-height:180px;outline:0;resize:none;font-family:", ";}.chatbot__wrapper{position:relative;}.chatbot__icon{width:12px;fill:#fff;margin-left:2px;}.chatbot__box{min-height:", ";max-height:", ";display:inline-block;width:100%;overflow-y:auto;margin:10px 0px 5px;box-sizing:border-box;}.chatbot__header{display:flex;align-items:center;justify-content:space-between;width:100%;background-color:", ";padding:0;box-sizing:border-box;border-top-left-radius:4px;border-top-right-radius:4px;padding:4px 8px;font-weight:bold;}.chatbot__header h2{margin:0;}.chatbot__controls{width:20px;height:20px;background-repeat:no-repeat;background-color:transparent;border:0;cursor:pointer;}.chatbot__controls--minimize{background-image:url(\"", "\");outline:none;}.chatbot__controls--expand{background-image:url(\"", "\");outline:none;}.chatbot__controls--close{background-image:url(\"", "\");}.chatbot.expand{width:995px;margin:0 auto;position:relative;z-index:0;}.expand .chatbot__content{height:100%;height:100vh;box-shadow:none;margin-bottom:30px;}form{margin:0 0 1.42857rem;}& .cAgentLine,& .cUserLine{background-color:", ";font-size:15px;box-sizing:border-box;color:", ";border-radius:5px;margin-bottom:5px;float:right;position:relative;margin-left:30px;clear:both;float:right;position:relative;line-height:15px;padding:7px 7px 5px;box-sizing:border-box;}.cUserLine{float:left;background-color:#a8a1a2;}& .cAgentLine::before,& .cUserLine::before{position:absolute;left:-25px;top:calc(50% - 10px);background-image:url(\"", "\");background-size:contain;background-repeat:no-repeat;background-position:center;content:' ';height:20px;background-color:", ";border-radius:50%;background-size:50%;width:20px;}& .cUserLine::before{background-image:url(\"", "\");background-color:#000;}"], fontFamilySystem, function (props) {
  return props.isExpanded ? '50vw' : '350px';
}, styles.chatbotBgColor, colorWhiteBase, fontFamilyBrandPrimary, fontFamilyBrandPrimary, colorWhiteBase, fontFamilySystem, function (props) {
  return props.isExpanded ? '40vh' : '80px';
}, function (props) {
  return props.isExpanded ? '50vh' : '30vh';
}, styles.chatbotBgColor, MinimizeIcon, ExpandIcon, CloseIcon, styles.chatbotBgColor, colorWhiteBase, BrandAvatar, styles.chatbotBgColor, UserAvatar);

var Chatbot = function Chatbot(_ref) {
  var setIsChatbotActive = _ref.setIsChatbotActive,
      setIsChatWindowOpen = _ref.setIsChatWindowOpen,
      isScriptLoading = _ref.isScriptLoading;

  var _useState = useState(''),
      inputState = _useState[0],
      setInputState = _useState[1];

  var searchParams = new URLSearchParams(window.location.search);
  var enterToggle = searchParams.get('enter-toggle');

  var _useState2 = useState(false),
      isExpanded = _useState2[0],
      setIsExpanded = _useState2[1];

  var _useState3 = useState(enterToggle ? enterToggle : false),
      isTogglerChecked = _useState3[0],
      setIsTogglerChecked = _useState3[1];

  useEffect(function () {
    if (!isScriptLoading) {
      // Fire Initialize function from chatbot script.
      Application.Initialize(); // Fire Unitialize function from chatbot script on beforeunload.

      window.addEventListener('beforeunload', Application.Unitialize);
      return function () {
        return (// Remove event listener from DOM after "beforeunload"
          window.removeEventListener('beforeunload', Application.Unitialize)
        );
      };
    }
  }, [isScriptLoading]);
  return !isScriptLoading && /*#__PURE__*/React.createElement(ChatbotExternalWrapper, {
    className: "chatbot expand",
    isExpanded: isExpanded
  }, /*#__PURE__*/React.createElement("div", {
    className: "chatbot__header"
  }, isExpanded ? /*#__PURE__*/React.createElement("button", {
    className: "chatbot__controls chatbot__controls--minimize",
    onClick: function onClick() {
      return setIsExpanded(false);
    }
  }) : /*#__PURE__*/React.createElement("button", {
    className: "chatbot__controls chatbot__controls--expand",
    title: "vergroten",
    onClick: function onClick() {
      return setIsExpanded(true);
    }
  }), /*#__PURE__*/React.createElement(Heading, {
    level: 4,
    color: "colorWhiteBase",
    fontFamily: "primary"
  }, "Chat met ons"), /*#__PURE__*/React.createElement("button", {
    className: "chatbot__controls chatbot__controls--close",
    title: "sluiten",
    onClick: function onClick() {
      setIsChatbotActive(false);
      setIsChatWindowOpen(false);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "chatbot__content"
  }, /*#__PURE__*/React.createElement("div", {
    id: "iChatConversation"
  }, /*#__PURE__*/React.createElement("div", {
    id: "iChatLinesAndTyping",
    className: "chatbot__box"
  }, /*#__PURE__*/React.createElement("div", {
    id: "iChatLines",
    title: "Hier wordt uw gesprek met De Gazet van Antwerpen getoond."
  }), /*#__PURE__*/React.createElement("div", {
    id: "iChatTyping",
    style: {
      display: 'none'
    }
  })), /*#__PURE__*/React.createElement("div", {
    id: "iChatInput"
  }, /*#__PURE__*/React.createElement("form", {
    acceptCharset: "utf-8",
    autoComplete: "off"
  }, /*#__PURE__*/React.createElement("div", {
    className: "chatbot__wrapper"
  }, isTogglerChecked ? /*#__PURE__*/React.createElement("input", {
    id: "iChatInputField",
    className: "cUntouched chatbot__input input",
    type: "text",
    autoComplete: "off",
    value: inputState,
    onChange: function onChange(e) {
      return setInputState(e.target.value);
    },
    onFocus: function onFocus(e) {
      if (e.currentTarget.className.includes('cUntouched')) {
        e.currentTarget.className = e.currentTarget.className.replace('cUntouched', '').substring(1);
      }
    },
    onKeyPress: function onKeyPress(e) {
      if (e.charCode === 13) {
        e.preventDefault();
        setInputState('');
      }

      if (gWebClient) {
        return gWebClient.ProcessKey(e, e.currentTarget);
      }

      return e;
    },
    placeholder: "Dit is mijn bericht",
    title: "Dit is mijn bericht",
    alt: "chat invoerveld",
    maxLength: "255"
  }) : /*#__PURE__*/React.createElement("textarea", {
    id: "iChatInputLargeField",
    placeholder: "Dit is mijn bericht",
    title: "Typ je bericht hier",
    className: "chatbot__input textarea",
    value: inputState,
    onChange: function onChange(e) {
      return setInputState(e.target.value);
    },
    onKeyPress: function onKeyPress(e) {
      if (gWebClient) {
        return gWebClient.ProcessKey(e, e.currentTarget, true);
      }

      return e;
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "cClear"
  }), /*#__PURE__*/React.createElement("div", {
    className: "enter-input"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "enter-toggle"
  }, "Enter om te versturen"), /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    name: "enter-toggle",
    id: "enter-toggle",
    className: "enter-toggle",
    checked: isTogglerChecked,
    onChange: function onChange() {
      return setIsTogglerChecked(!isTogglerChecked);
    }
  }), /*#__PURE__*/React.createElement("a", {
    href: "",
    onClick: function onClick(e) {
      e.preventDefault();
      setInputState('');

      if (gWebClient) {
        gWebClient.SubmitUserMessage(null);
      }

      return false;
    },
    className: "chatbot__send2",
    title: "verzenden"
  }, "verzenden")))))));
};

export default Chatbot;